import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const showPdpFulfillmentSelectorSelector = createSelector(testTargetOffersSelector, offers => offers.showPdpFulfillmentSelector || Empty.Object);

export { showPdpFulfillmentSelectorSelector };
